module.exports = __webpack_public_path__ + "bb38e72152c58c9033b4b28826e60788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_6.jpg
// module id = 1751
// module chunks = 5